import React, { useEffect, useState } from "react";
import img from "../../assets/images/mcarehd.png";
import { Link } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { Collapse, Spin } from "antd";
import Nav from "../landing-pages/home-two/components/nav";
import Footer2 from "../landing-pages/home-two/components/footer2";
import DataProvider from "../../services";
import { packageDetails } from "../../store";

const { Panel } = Collapse;

type ExpandIconPosition = "start" | "end";

export default function Packages() {
  const [expandIconPosition] = useState<ExpandIconPosition>("end");
  const [packages, setPackages] = useState<packageDetails[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    DataProvider.getAllPackages()
      .then(({ data }) => setPackages(data))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, []);

  // const handlePositionChange = (newPosition: ExpandIconPosition) => {
  //   setExpandIconPosition(newPosition);
  // };

  // const genExtra = () => (
  //   <SettingOutlined
  //     onClick={(event) => {
  //       // Prevent collapse toggle when clicking the icon
  //       event.stopPropagation();
  //     }}
  //   />
  // );

  return (
    <div className="min-h-screen bg-gray-100">
      <Nav className="fixed top-0 right-0 z-50 bg-white/90 backdrop-blur-md" />
      <div
        className="w-full flex justify-center items-center h-[30vh] sm:h-[50vh] bg-cover bg-[#1A94ECB5] bg-blend-overlay"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="ml-4 sm:ml-10 flex flex-col justify-center items-center mt-10 sm:mt-20">
          <h1 className="text-2xl sm:text-4xl text-white font-bold text-center">
            Mcare Packages
          </h1>
          <div className="mt-4 flex flex-row items-center text-sm sm:text-lg">
            <Link
              to="/"
              className="text-[#ffffff] hover:text-gray-300 font-medium"
            >
              Home
            </Link>
            <div className="mx-2">
              <RightOutlined style={{ color: "white", fontSize: "15px" }} />
            </div>
            <Link to="/packages" className="text-[#ffffff] font-medium">
              Packages
            </Link>
          </div>
        </div>
      </div>

      {/* Package Section */}
      <div className="mt-5 px-4 sm:px-8">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-center mb-8 text-gray-800">
          Choose Your Package
        </h1>
        {/* <div className="text-center mb-4">
          <span>Expand Icon Position: </span>
          <Select
            value={expandIconPosition}
            style={{ margin: "0 8px" }}
            onChange={handlePositionChange}
          >
            <Option value="start">start</Option>
            <Option value="end">end</Option>
          </Select>
        </div> */}

        {loading ? (
          <div className="flex justify-center py-20">
            <Spin size="large" />
          </div>
        ) : (
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 mb-20">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className="bg-white rounded-lg shadow-lg p-4 sm:p-6 hover:shadow-2xl transition duration-300 flex flex-col justify-between h-full"
              >
                <div>
                  <h2 className="text-2xl font-extrabold mb-4 text-gray-800">
                    {pkg.description}
                    <div className="flex">
                      <p className="text-sm font-bold text-gray-500 mb-4">
                        Gh¢ {Number(pkg.price).toFixed(2)}
                        <span className="text-sm">/month </span>
                      </p>
                      <p className="text-gray-500 font-medium text-sm mb-4">
                        ({pkg.offers.map((o) => o.name).join(" + ")})
                      </p>
                    </div>
                  </h2>
                  <div className="mb-8">
                    <Link to="/sign-up">
                      <button className="w-full bg-[#F7CB31] text-black py-2 rounded-lg font-semibold hover:bg-yellow-400 transition duration-300 mt-auto">
                        Buy {pkg.description}
                      </button>
                    </Link>
                  </div>

                  <Collapse
                    accordion
                    expandIconPosition={expandIconPosition}
                    defaultActiveKey={["0"]}
                  >
                    {pkg.offers.map((offer, idx) => (
                      <Panel
                        header={
                          <span className="font-semibold text-gray-800">
                            {offer.name}
                          </span>
                        }
                        key={String(idx)}
                      >
                        <ul className="space-y-2">
                          {offer.list.map((item, index) => (
                            <li key={index} className="text-sm text-gray-600">
                              {item}
                            </li>
                          ))}
                        </ul>
                      </Panel>
                    ))}
                  </Collapse>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer2 />
    </div>
  );
}
